import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import { useAuth } from '../context/AuthContext';

const DashboardPage = () => {
  const { currentUser, userTemplate, userCompany } = useAuth();

  // Configuração dinâmica baseada no template
  const dashboardConfig = {
    real_estate: {
      title: 'Dashboard Imobiliário',
      description: 'Gerencie seus contratos imobiliários',
      stats: [
        {
          label: 'Contratos Ativos',
          value: '-',
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          ),
          color: 'bg-primary-500'
        },
        {
          label: 'Este Mês',
          value: '-',
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          ),
          color: 'bg-emerald-500'
        },
        {
          label: 'Pendentes',
          value: '-',
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          ),
          color: 'bg-blue-500'
        }
      ],
      quickActions: [
        {
          title: 'Contrato de Locação',
          description: 'Crie um contrato de aluguel residencial ou comercial',
          icon: (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
          ),
          href: '/contratos/novo'
        },
        {
          title: 'Compra e Venda',
          description: 'Gere um contrato de compra e venda de imóvel',
          icon: (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          ),
          href: '/contratos/novo'
        },
        {
          title: 'Administração',
          description: 'Contrato de administração predial',
          icon: (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          ),
          href: '/contratos/novo'
        }
      ]
    },
    ebes_solar: {
      title: 'Dashboard EBES Solar',
      description: 'Gerencie suas instalações de energia fotovoltaica',
      stats: [
        {
          label: 'Projetos Ativos',
          value: '-',
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          ),
          color: 'bg-yellow-500'
        },
        {
          label: 'Este Mês',
          value: '-',
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          ),
          color: 'bg-green-500'
        },
        {
          label: 'Em Instalação',
          value: '-',
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          ),
          color: 'bg-orange-500'
        }
      ],
      quickActions: [
        {
          title: 'Novo Contrato Solar',
          description: 'Criar contrato de fornecimento e instalação de usina fotovoltaica',
          icon: (
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          ),
          href: '/contratos/novo',
          primary: true
        }
      ]
    }
  };

  const config = dashboardConfig[userTemplate] || dashboardConfig.real_estate;

  return (
    <div className="min-h-screen bg-neutral-50">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Cabeçalho */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-dark-900 mb-2">
            Olá, {currentUser}!
          </h1>
          <p className="text-neutral-600">
            {config.description}
          </p>
          {userCompany && (
            <p className="text-sm text-neutral-500 mt-1">
              {userCompany}
            </p>
          )}
        </div>

        {/* Estatísticas */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {config.stats.map((stat, index) => (
            <div key={index} className="card p-6">
              <div className="flex items-center">
                <div className={`${stat.color} p-3 rounded-lg text-white`}>
                  {stat.icon}
                </div>
                <div className="ml-4 flex-1">
                  <p className="text-sm font-medium text-neutral-600">
                    {stat.label}
                  </p>
                  <div className="flex items-center">
                    <p className="text-2xl font-bold text-dark-900">
                      {stat.value}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Ações Rápidas */}
          <div className="lg:col-span-2">
            <div className="card p-6">
              <h2 className="text-xl font-semibold text-dark-900 mb-6">
                Ações Rápidas
              </h2>
              
              {/* Layout especial para EBES Solar - Uma única ação destacada */}
              {userTemplate === 'ebes_solar' ? (
                <Link
                  to={config.quickActions[0].href}
                  className="block p-8 border-2 border-primary-300 bg-gradient-to-br from-yellow-50 to-orange-50 rounded-xl hover:border-primary-500 hover:shadow-lg transition-all duration-200 group"
                >
                  <div className="flex items-center mb-4">
                    <div className="text-yellow-600 group-hover:text-yellow-700 group-hover:scale-110 transition-transform">
                      {config.quickActions[0].icon}
                    </div>
                    <h3 className="ml-4 text-2xl font-bold text-dark-900 group-hover:text-primary-700">
                      {config.quickActions[0].title}
                    </h3>
                  </div>
                  <p className="text-neutral-600 mb-4 leading-relaxed">
                    {config.quickActions[0].description}
                  </p>
                  <div className="flex items-center text-primary-600 group-hover:text-primary-700 font-medium">
                    <span>Criar Contrato Agora</span>
                    <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </Link>
              ) : (
                /* Layout grid para imobiliário */
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {config.quickActions.map((action, index) => (
                    <Link
                      key={index}
                      to={action.href}
                      className="block p-4 border border-neutral-200 rounded-lg hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 group"
                    >
                      <div className="text-primary-500 group-hover:text-primary-600 mb-3">
                        {action.icon}
                      </div>
                      <h3 className="font-semibold text-dark-900 mb-2 group-hover:text-primary-700">
                        {action.title}
                      </h3>
                      <p className="text-sm text-neutral-600">
                        {action.description}
                      </p>
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {/* Informação sobre dados */}
            <div className="card p-6 mt-6">
              <div className="flex items-start">
                <svg className="w-5 h-5 text-blue-500 mt-0.5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div>
                  <h3 className="font-semibold text-dark-900 mb-2">
                    Sistema em Desenvolvimento
                  </h3>
                  <p className="text-sm text-neutral-600 leading-relaxed">
                    As estatísticas e histórico de contratos serão habilitados em breve. 
                    Por enquanto, você pode criar novos contratos usando {userTemplate === 'ebes_solar' ? 'a ação' : 'as ações'} acima.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Dica do Dia */}
            <div className="card p-6">
              <h3 className="font-semibold text-dark-900 mb-3">
                💡 Dica do Dia
              </h3>
              <p className="text-sm text-neutral-600 leading-relaxed">
                {userTemplate === 'ebes_solar' 
                  ? 'Sempre verifique a orientação e inclinação do telhado antes de dimensionar o sistema fotovoltaico.'
                  : 'Use a função de preview do contrato para revisar todas as informações antes de gerar o PDF final.'
                }
              </p>
            </div>

            {/* Links Úteis */}
            <div className="card p-6">
              <h3 className="font-semibold text-dark-900 mb-4">
                🔗 Links Úteis
              </h3>
              <div className="space-y-3">
                <Link 
                  to="/contratos/novo" 
                  className="flex items-center text-sm text-primary-600 hover:text-primary-700 transition-colors"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Criar Novo Contrato
                </Link>
                
                {userTemplate === 'ebes_solar' && (
                  <>
                    <a 
                      href="https://www.aneel.gov.br" 
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center text-sm text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                      Portal ANEEL
                    </a>
                    <a 
                      href="https://www.absolar.org.br" 
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center text-sm text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                      ABSOLAR
                    </a>
                  </>
                )}
              </div>
            </div>

            {/* Status do Sistema */}
            <div className="card p-6 bg-green-50 border-green-200">
              <div className="flex items-center">
                <div className="w-3 h-3 bg-green-500 rounded-full mr-3 animate-pulse"></div>
                <div>
                  <h3 className="font-semibold text-green-900 text-sm">
                    Sistema Online
                  </h3>
                  <p className="text-xs text-green-700">
                    Todos os serviços funcionando
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DashboardPage;